import { ArrowUpRight, UserPlus } from "lucide-react";

import StagePage from "src/stage/StagePage";
import { Skeleton } from "src/stage/StageUi";
import { autoAppyUrl } from "src/config/autoAppyUrls";
import { useWorkspace } from "../context/WorkspaceContext";
import TeamDirectory from "./TeamDirectory";
import { HelpTip } from "src/features/Stage/shared/StageKit";
import "./team-stage.css";

// AUTO-CRM-32: Team on the Stage layer. People, roles and access are managed
// in Auto Appy's Organisation page; the CRM shows who works the leads.
export default function TeamPage() {
  const { loading, currentWorkspace } = useWorkspace();

  if (loading) {
    return (
      <StagePage>
        <Skeleton width={180} height={11} />
        <Skeleton width={260} height={32} radius={12} />
        <Skeleton height={88} radius={20} />
        <Skeleton height={360} radius={20} />
      </StagePage>
    );
  }

  if (!currentWorkspace) {
    return (
      <StagePage eyebrow="Work · Team" title="Team">
        <div className="ws-empty">Create or join a workspace before managing team members.</div>
      </StagePage>
    );
  }

  const organisationUrl = autoAppyUrl(`/organisation${currentWorkspace.autoappy_workspace_id ? `?organisation=${encodeURIComponent(currentWorkspace.autoappy_workspace_id)}` : ""}`);

  return (
    <StagePage
      className="crm-team-page"
      eyebrow={<>Work<span className="crm-eyebrow-dot" />Team</>}
      title="Team"
      subtitle={<>Everyone working leads in {currentWorkspace.name}: their role, who they report to and how they’re doing. Each lead has an <HelpTip term="owner">owner</HelpTip> who follows it up.</>}
      actions={(
        <>
          <span className="ws-chip crm-role-chip"><span className="ws-status ws-status--live" />{currentWorkspace.current_user_role || "member"} view</span>
          <a className="ws-btn ws-btn--quiet" href={organisationUrl}>Roles and access<ArrowUpRight size={14} /></a>
          <a className="ws-btn ws-btn--primary" href={organisationUrl}><UserPlus size={15} />Invite people</a>
        </>
      )}
    >
      <TeamDirectory organisationUrl={organisationUrl} />
    </StagePage>
  );
}
